import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {NzMessageService, NzModalService} from 'ng-zorro-antd';
import {DASHBOARDSERVICE} from './config';
import {DashboardComponent} from './dashboard.component';
import {UserAddDashboardComponent} from './components/user-add-dashboard.component';
import {BuiltInAddDashboardComponent} from './components/built-in-add-dashboard.component';

@Component({
    selector: 'zj-dashboard',
    template: `
        <!-- æä¾æ´æ¹ä¸»é¢æ°ç®çæä½ -->
        <nz-dropdown nzTrigger="click" nzPlacement="bottomRight">
            <span class="anticon anticon-setting" nz-dropdown></span>
            <div style="width:150px">
                <div class="theme-switch" (click)="deleteCurrentPage()">
                    å é¤å½åä¸»é¢
                </div>
                <div (click)="configPages()">
                    æ°å¢ç³»ç»ä¸»é¢
                </div>
                <div (click)="openUserAdd()">
                    æ°å¢èªå®ä¹ä¸»é¢
                </div>
            </div>
        </nz-dropdown>
        <zj-carousel [panels]="panels" [zjArrows]="false" (onActive)="activatePage($event)"></zj-carousel>
    `,
    styles: [
            `
            nz-dropdown {
                position: absolute;
                z-index: 1;
                font-size: 20px;
                right: 40px;
            }

            .anticon.anticon-setting:hover {
                color: #21e616;
                cursor: pointer;
            }
        `
    ]
})
export class ZijinDashboardComponent implements OnInit {

    // å½åå·²éç½®çä¸»é¢é¡¹
    pages = [];
    // è·åææä¸»é¢é¡¹
    pendingPages = [];

    pageActivating;

    pageSelected;

    panels = [];
    @Output() onDeletePage = new EventEmitter();

    constructor(private message: NzMessageService,
                private modal: NzModalService,
                @Inject(DASHBOARDSERVICE) private dashboardService) {

    }

    ngOnInit(): void {
        this.getMultiPagesMeta();
        this.getAllPagesMeta();
    }

    configPages() {

        const pendingPages = [].concat(this.pendingPages);

        pendingPages.forEach(val => {
            this.pages.forEach(v => {
                if (val.pageId === v.pageId) {
                    val.available = false;
                    val.selected = true;
                }
            });
            if (!val.hasOwnProperty('selected')) {
                val.available = true;
                val.selected = false;
            }
        });

        const subject = this.modal.open({
            title: 'éæ©ç³»ç»åç½®ä¸»é¢',
            width: 600,
            maskClosable: false,
            content: BuiltInAddDashboardComponent,
            componentParams: {
                pages: pendingPages
            }
        });
        subject.subscribe(data => {
            console.log(data);
            if (data.selected) {
                this.pageSelected = data;
            }
        });

        subject.on('onOk', () => {
            this.addPage();
        });
    }

    addPage() {
        if (!this.pageSelected) {
            return;
        }
        console.log(this.pageSelected);
        this.dashboardService.addNewPageDef({
            pageId: this.pageSelected.pageId
        }).subscribe(data => {
            this.pageSelected = null;
            this.getMultiPagesMeta();
        }, err => {
            this.message.error(err.body.retMsg);
        });
    }

    activatePage(page) {
        this.pageActivating = page.pageId;
    }

    deleteCurrentPage() {
        if (this.panels.length === 1) {
            this.message.error('è³å°æä¸ä¸ªä¸»é¢');
            return;
        }
        this.dashboardService.deletePageById(this.pageActivating)
            .subscribe(data => {
                this.onDeletePage.emit('å é¤é©¾é©¶è±æå');
                this.getMultiPagesMeta();
                this.getAllPagesMeta();
            }, err => {
                this.message.error(err.body.retMsg);
            });
    }

    openUserAdd() {
        // å¤æ­ç¨æ·æ¯å¦å·²æèªå®ä¹ä¸»é¢

        let hasAdded = false;
        this.pendingPages.forEach(p => {
            if (p.pageTye === '1') {
                hasAdded = true;
            }
        });
        if (hasAdded) {
            this.message.error('æ¨å·²æ·»å è¿èªå®ä¹ä¸»é¢');
            return;
        }
        this.modal.open({
            title: 'èªå®ä¹ä¸»é¢',
            width: 600,
            footer: false,
            maskClosable: false,
            content: UserAddDashboardComponent,
        }).on('onOk', () => {
            this.getMultiPagesMeta();
        });
    }

    // è·åå½åç¨æ·ä¸çä¸»é¢é¡¹
    getMultiPagesMeta() {
        this.dashboardService.getMultiPagesMeta()
            .subscribe(data => {
                this.panels = [];
                this.pages = [];
                data.forEach(val => {
                    this.panels.push({
                        data: {pageId: val.pageId},
                        component: DashboardComponent
                    });
                    this.pages.push({pageId: val.pageId});
                });
            }, err => {
                this.message.error(err.body.retMsg);
            });
    }

    // è·åç¨æ·å¯éçææä¸»é¢
    getAllPagesMeta() {
        this.dashboardService.getAllPagesMeta()
            .subscribe(data => {
                this.pendingPages = data;
            }, err => {
                this.message.error(err.body.retMsg);
            });
    }


}
